import React from 'react';
import ReactDOM from 'react-dom';
import './config';
import './utils/cachedFetch';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from "react-redux";
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import store from "./store.js";
import Home from "./views/Home";
import Mockups from "./views/Mockups";
import Mockup from "./views/MockupPage";
import ReduxToastr from 'react-redux-toastr';
import Designs from './views/Designs';
import Orders from './views/orders';
import Dashboard from './views/Dashboard';
import MainPage from './views/MainPage';
import Share from './views/Share';
import NewRender from './views/NewRender';
import DesignPage from './views/DesignPage';
import OrderConfirmation from "./views/OrderConfirmation";


ReactDOM.render(<Provider store={store}>
        <BrowserRouter>
            <App>
                <Switch>
                    <Route exact path="/" component={MainPage}/>
                    <Route exact path="/mockupmaker/start" component={Home}/>
                    <Route exact path='/designmaker/start' render={(props) => <Dashboard {...props}/>}/>
                    <Route exact path='/designmaker/start/templates' render={(props) => <Dashboard {...props}/>}/>
                    <Route path='/mockupmaker/start/mockups/:mockup_id' component={Mockup}/>
                    <Route path='/mockupmaker/start/saved_mockups/:saved_mockup_id' component={Mockup}/>
                    <Route path='/mockupmaker/start/category/:category_id' component={Mockups}/>
                    <Route path='/mockupmaker/start/search/' component={Home}/>
                    <Route path="/designmaker/start/search" render={(props) => <Dashboard {...props}/>}/>
                    <Route path='/designmaker/start/designs/:design_id/:role' component={Designs}/>
                    <Route path="/designmaker/start/template/:custom_url" render={(props) => <DesignPage {...props}/>}/>
                    <Route path='/designmaker/start/orders/confirm-order' component={OrderConfirmation}/>
                    {/*<Route path='/orders/confirm-order' component={OrderConfirmation}/>*/}
                    <Route path='/designmaker/start/orders' component={Orders}/>
                    <Route path='/designmaker/start/design-orders/' render={(props) => <Dashboard {...props}/>}/>
                    <Route path='/designmaker/start/brand-kit/' render={(props) => <Dashboard {...props}/>}/>
                    <Route path='/designmaker/start/generate-designs/' render={(props) => <Dashboard {...props}/>}/>
                    <Route path='/designmaker/start/shared-designs/' render={(props) => <Dashboard {...props}/>}/>
                    <Route path='/designmaker/start/folders/' render={(props) => <Dashboard {...props}/>}/>
                    <Route exact path='/designmaker/start/categories' render={(props) => <Dashboard {...props}/>}/>
                    <Route path='/designmaker/start/admin_designs/:design_id/:role'
                           render={() => store.getState().user && (store.getState().user.type == 'admin' || store.getState().user.type == 'designer') ? (
                               <Designs></Designs>) : (<div>Authenticating...</div>)} component={Designs}/>
                    <Route path='/designmaker/start/admin_text_templates/:template_id/:role' component={Designs}/>
                    <Route path='/designmaker/start/all-designs' render={(props) => <Dashboard {...props}/>}/>
                    <Route path='/designmaker/start/wizard' render={(props) => <Dashboard {...props}/>}/>
                    <Route path='/designmaker/start/share/:resource_type/:id' render={(props) => <Share {...props}/>}/>
                    <Route path='/designmaker/start/new_render/:id' render={(props) => <NewRender {...props}/>}/>
                    <Route render={() => (<div>Not Found</div>)}/>
                </Switch>
                <ReduxToastr
                    position="bottom-right"
                />
            </App>
        </BrowserRouter>
    </Provider>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();



    

